import React from "react";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Props {
  onInquire: () => void;
}

const ComingSoonPackageCard: React.FC<Props> = ({ onInquire }) => {
  const { t } = useTranslation();
  return (
    <div className="rounded-2xl border-2 border-dashed border-brand-400/50 bg-brand-50/30 flex flex-col items-center justify-center text-center p-8 h-full min-h-[22rem]">
      <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-brand-600 to-brand-400 text-navy-950 mb-5 shadow-gold">
        <Sparkles size={26} strokeWidth={2} />
      </div>
      <h3 className="font-serif text-xl font-bold text-navy-900 mb-2">
        {t("packages.comingSoonCard.title")}
      </h3>
      <p className="text-navy-900/55 text-sm leading-relaxed mb-6">
        {t("packages.comingSoonCard.desc")}
      </p>
      <button
        onClick={onInquire}
        className="border-2 border-brand-600 text-brand-700 font-bold text-sm px-5 py-2.5 rounded-full hover:bg-brand-600 hover:text-white transition-all"
      >
        {t("packages.comingSoonCard.button")}
      </button>
    </div>
  );
};

export default ComingSoonPackageCard;
